export var CreditStatus;
(function (CreditStatus) {
    CreditStatus["Fair"] = "FAIR";
    CreditStatus["Unknown"] = "UNKNOWN";
    CreditStatus["Average"] = "AVERAGE";
    CreditStatus["Excellent"] = "EXCELLENT";
})(CreditStatus || (CreditStatus = {}));
//# sourceMappingURL=CreditStatus.js.map